
import Site from './Site.vue';
import Header from './Header.vue';
import Content from './Content.vue';
import ZETO from './ZETO.vue';
import MasterSlave from './MasterSlave.vue';
import ProgressBar from './ProgressBar.vue';
import Bubble from './Bubble.vue';
import Tested from './Tested.vue';
import Release from './Release.vue';
import Actions from './Actions.vue';

export default {
    install(app) {
        app.component('z-site', Site);
        app.component('z-header', Header);
        app.component('z-content', Content);
        app.component('z-logo', ZETO);
        app.component('z-master-slave', MasterSlave);
        app.component('z-progress', ProgressBar);
        app.component('z-bubble', Bubble);
        app.component('z-tested', Tested);
        app.component('z-release', Release);
        app.component('z-actions', Actions);
    }
};
